import $appConfig from 'servicestack/config'
import session from 'servicestack/session'

export default () => (scope, el, attrs) => {
    $appConfig.initPlugin(attrs);
    session.get().then(() => $appConfig.init(session));
}
